class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.block = this.closest('[data-block-type="complementary-products"]');
    this.container = this.querySelector("[data-products-container]");
    this.intent = this.dataset.intent;
    this.max_products = this.getAttribute("data-max-products");
    this.product_id = this.getAttribute("data-product-id");

     // Store found product IDs in a static property or global variable
     if (!this.constructor.foundProductIds) {
      this.constructor.foundProductIds = [];
       }
      // If current product_id is blank/null/undefined, use the last found one
      if (!this.product_id && this.constructor.foundProductIds.length > 0) {
      this.product_id = this.constructor.foundProductIds[this.constructor.foundProductIds.length - 1];
      console.log("Using previously found product ID:", this.product_id);
      // Optionally set the attribute on the element
      this.setAttribute("data-product-id", this.product_id);
       }
      // If we have a valid product_id, store it
      if (this.product_id) {
      this.constructor.foundProductIds.push(this.product_id);
     }
    
    // Set initial display to none (will show if we get recommendations)
    this.style.display = "none";
    
    this.load().catch(error => {
      console.error("Failed to load product recommendations:", error);
      // Hide the container if there's an error or no recommendations
      if (this.block) {
        this.block.style.display = "none";
      }
    });
  }

  async load() {
  try {
    const t = await fetch(`${theme.urls.product_recommendations}?section_id=${this.intent}-products&limit=${this.max_products}&product_id=${this.product_id}&intent=` + this.intent);

    if (!t.ok) {
      console.warn("Product recommendations request failed:", t.statusText);
      this.block && (this.block.style.display = "none");
      return;
    }

    const e = await t.text();
    const o = theme.utils.parseHtml(e).querySelectorAll("[data-product-item]");

    if (o.length) {
      const s = new DocumentFragment;
      o.forEach(t => s.append(t));
      this.container.innerHTML = "";
      this.container.appendChild(s);
      theme.transitions.reload("related-products");
      theme.transitions.reload("complementary-products");
      this.style.display = "block";
    } else {
      this.block && (this.block.style.display = "none");
    }
  } catch (err) {
    console.warn("Error loading product recommendations:", err);
    this.block && (this.block.style.display = "none");
  }
}

}

// Register the custom element if not already registered
const productRecommendationsEl = customElements.get("product-recommendations-root");
if (!productRecommendationsEl) {
  customElements.define("product-recommendations-root", ProductRecommendations);
}